var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.92004,
    y: 5.79999,
    width: 22.08,
    height: 2.88,
    rx: 1.44,
    fill: "#7E7E7E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6433,
    y: 21.8323,
    width: 21.275,
    height: 2.88,
    rx: 1.44,
    transform: "rotate(-78.2907 12.6433 21.8323)",
    fill: "#7E7E7E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.83997,
    y: 21.8323,
    width: 21.275,
    height: 2.88,
    rx: 1.44,
    transform: "rotate(-78.2907 3.83997 21.8323)",
    fill: "#7E7E7E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 14.44,
    width: 22.08,
    height: 2.88,
    rx: 1.44,
    fill: "#7E7E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.d7679624.svg";
export { ForwardRef as ReactComponent };